import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBezierAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBezierAdd"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3V9H5.25V15H3V21H8.75V18.75H15V21H21V15H18.75V9H21V3H15V5.25H9V3H3ZM9 9V6.75H15V9H17.25V15H15V17.25H8.75V15H6.75V9H9Z" fill="currentColor"/><Path d="M12.75 9H11.25V11.25H9V12.75H11.25V15H12.75V12.75H15V11.25H12.75V9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBezierAdd;
